/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RingBufferLength {
    _10240_0_25_sec = 10240,
    _20480_0_5_sec = 20480,
    _40960_1_sec = 40960,
    _81920_2_sec = 81920,
}
